module.exports = __webpack_public_path__ + "static/media/add.b46370ad.svg";